// src/config.js
export const BASE_URL = (process.env.REACT_APP_BACKEND_URL || "http://localhost:5000").replace(/\/+$/, "");
//export const BASE_URL = (process.env.REACT_APP_BACKEND_URL || "https://atlascrmapi.ceylonx.lk").replace(/\/+$/, "");
//export const BASE_URL = (process.env.REACT_APP_BACKEND_URL || "https://crm-atlas-backend-9fm4.onrender.com").replace(/\/+$/, "");
// https://crm-atlas-backend-9fm4.onrender.com- new live
// https://crm-atlas-backend.onrender.com-old live

